import { provideMockStore } from '@ngrx/store/testing';
import { transformTableStateRegister } from './table.reducer';
import { TableState } from './table-definition';

export function getStoreStateWithTable<D, C = any>(tableId: string, tableRegister: Partial<TableState<D, C>>) {
  return {
    dx: {
      tables: {
        [tableId]: transformTableStateRegister(tableRegister, tableId),
      }
    }
  }
}

export function provideMockStoreWithTables<D, C = any>(tableId: string, tableRegister: Partial<TableState<D, C>>) {
  return provideMockStore({
    initialState: getStoreStateWithTable(tableId, tableRegister),
  })
}
